import React from "react";
import { styled } from "@mui/system";
import MUIAccordion, { AccordionProps } from "@mui/material/Accordion";

export const Accordion = styled(
  (props: AccordionProps) => <MUIAccordion {...props} />,
  {
    name: "Accordion",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiAccordion-root": {
    marginTop: 0,
    marginBottom: 0,
  },
}));
